/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// var stockcnt = document.getElementById('stockcount').innerHTML;
// if (stockcnt==1){
//  document.getElementById('stock').InnerHTML="Out of Stock";
// }else{
// document.getElementById('stock').InnerHTML="In Stock";
// }
// $(document).ready(function(){
//   var href = (window.location.href);
//    if(window.location.href.indexOf("?variant=") > -1) {
//       href = href.split("=");
//      href = href[1];
     
//     }
//   else{
  
//   }
// })

$(document).ready(function(){
  
  
  
            
  $(document).mouseup(function (e){

      var container = $("#headr-search");

      if (!container.is(e.target) && container.has(e.target).length === 0){

          container.fadeOut();

      }
  }); 
   
  
  $(".Header__SecondaryNav .HorizontalList__Item").on("mouseleave", function() {
       $(this).removeClass("is-expanded");  //or $('.overlay').hide()
       //$(".Header__SecondaryNav .HorizontalList__Item:first-child .DropdownMenu").hide();
       $(".Header__SecondaryNav .HorizontalList__Item .DropdownMenu").attr('aria-hidden', true);
  });
  
}); 




